import React from 'react';

// Marketing landing page, shown at "/about". Content deliberately mirrors
// backend/middleware/school.go's landingPage constant (served server-side
// for a bare base domain, e.g. visiting "lunchday.app" directly, and also
// at "/about" on any host in production) — this route exists so the same
// page also works in the CRA dev server (SandwichWizard.js's AboutUsFooter
// links here), where nothing ever reaches the Go backend's routing at all.
// Keep the copy here in sync with landingPage's if either one changes.
export default function AboutPage() {
  return (
    <div style={{ maxWidth: '640px', margin: '0 auto', padding: '4rem 1.5rem', textAlign: 'center' }}>
      <h1 style={{ fontSize: '2.25rem', marginBottom: '0.5rem' }}>🥪 Lunchday</h1>
      <p style={{ fontSize: '1.15rem', color: '#555', marginBottom: '2.5rem' }}>
        Group lunch ordering for schools and nonprofits.
      </p>

      <div style={{
        background: 'white',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '1.75rem',
        textAlign: 'left',
        marginBottom: '1.5rem',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
      }}>
        <h2 style={{ marginTop: 0, fontSize: '1.1rem' }}>Order day made simple</h2>
        <p style={{ marginBottom: 0, color: '#555', lineHeight: 1.5 }}>
          Lunchday helps schools, PTOs, and nonprofits run group lunch order days —
          each person places and pays for their own order online, and staff get an
          organized, ready-to-deliver summary instead of a stack of paper order
          forms.
        </p>
      </div>

      <div style={{
        background: 'white',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '1.75rem',
        textAlign: 'left',
        marginBottom: '1.5rem',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
      }}>
        <h2 style={{ marginTop: 0, fontSize: '1.1rem' }}>Built for your organization</h2>
        <p style={{ marginBottom: 0, color: '#555', lineHeight: 1.5 }}>
          Each organization gets its own branded ordering page, pricing, payment
          options, and schedule — no two group's setup has to look the same.
        </p>
      </div>

      <p style={{ marginTop: '2.5rem', color: '#555' }}>
        Have questions, or want to set up Lunchday for your school or nonprofit?
        Reach out at <a href="mailto:hello@lunchday.app" style={{ color: '#007bff', textDecoration: 'none' }}>hello@lunchday.app</a>.
      </p>
    </div>
  );
}
